import { MutableRefObject, useState } from "react";
import { MenuIcon } from "../../../icons";
import { MenuItem } from "../../../views/MainScreen";
import { Autocomplete } from "../../autocomplete/Autocomplete";
import { Module } from "../navbar/Module";
import Notifications from "../navbar/Notifications";
import { User } from "../navbar/User";
import SidebarLink from "./SidebarLink";
import MoneyExplosion from "../../animations/BillsAnimation";

export type SidebarProps = {
    menu: MenuItem[];
    explosionContainerRef: MutableRefObject<HTMLDivElement | null>;
};

function Sidebar({ menu, explosionContainerRef }: SidebarProps) {
    const [toggle, setToggle] = useState(false);

    return (
        <div className="overflow-visible">
            <div className="md:hidden flex justify-start bg-color1 sticky top-0 z-50">
                <div className="w-full flex items-center">
                    <MenuIcon
                        onClick={() => setToggle(!toggle)}
                        className="text-color8 md:hidden  fill-current w-10 h-10 cursor-pointer m-2"
                    />
                    <Autocomplete />
                </div>
                <div className="ml-auto flex items-center w-3/5 justify-end gap-x-2">
                    <Module />
                    <Notifications />
                    <User />
                </div>
            </div>
            <div
                className={`flex flex-col bg-color1 overflow-visible  overflow-y-auto scrollbar-hide md:sticky text-color8 md:h-screen md:top-0
        font-inter font-normal text-r-large md:min-h-screen transition-all  ${toggle ? " sticky top-[var(--sidebar-height-mobile)] body-scroll-none h-screen" : ""
                    } `}
            >
                <div
                    className={`md:flex overflow-visible flex transition-all items-center sidebar-link`}
                >
                    <div
                        className={`relative flex overflow-visible w-full h-full justify-center bg-color7 items-center`}
                    >
                        <MoneyExplosion containerRef={explosionContainerRef} />
                    </div>
                </div>
                <div
                    className={`transition-all overflow-visible flex flex-col ${toggle ? "" : "h-0"
                        }`}
                >
                    {menu.map((item) => {
                        return (
                            <SidebarLink
                                toggleFunction={setToggle}
                                name={item.name}
                                url={item.url}
                                Icon={item.icon}
                                key={`sidebar-link-${item.name}`}
                                active={item.active}
                                tooltip={item.tooltip}
                                notifications={item.notification}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
